export enum IdTypeEnum {
  BUSINESS_ACCOUNT = 'business_account',
  USER = 'user',
  WALLET = 'wallet',
}